<template>
  <div class="p-fluid">
    <div class="p-col-12 p-lg-12">
      <CustomBreadcrumb :items="items_bread_crumb"  />
      <div class="card card-w-title">
        <div class="row manager-title-row">
          <div class="p-col-4 manager-title-custom">{{ title }}</div>
        </div>
        <!-- <div class="note">(*) Nội dung không được bỏ trống</div> -->
        <formEdit :key="componentKey" :mode="mode" @back="backToList" @save="saveData" :triggerSave.sync="triggerSave"
          :model="models" />
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment-timezone";
import DataServices from '@/core/DataServices'
import formEdit from './add'
import gql from "graphql-tag";
export default {
  components: {
    formEdit
  },
  data() {
    return {
      items_bread_crumb: [
        { label: 'Purchase Request', to: '/admin/list-rental_order_sell' },
        { label: '' }
      ],
      users: null,
      validationErrors: [],
      title: "Create new Car For Sell",
      mode: 'add',
      models: {},
      modelsColor: {},
      modelsCarSellSlug: {},
      componentKey: 1,
      accountID: '',
      page_transaction: null,
      active_check: true,
      users_clubs_id: '',
      numberCarSellAuto : [],
      time_zone_local: moment.tz.guess(true),
      triggerSave: false
    }
  },
  async mounted() {
   
    
    console.log("this.$route.name:", this.$route.query.page_transaction);
    this.mode = this.$route.name === 'edit' ? 'edit' : this.mode;
    if (this.$route.params.id !== undefined) await this.getData(this.$route.params.id);
    this.title = this.mode === 'edit' ? 'Edit #' + this.models?.rental_order?.code : this.title;
    this.items_bread_crumb[1].label = this.title;

    if (!this.$commonFuction.isEmpty(this.$route.query)) {
      if (!this.$commonFuction.isEmpty(this.$route.query.page_transaction)) {
        this.page_transaction = this.$route.query.page_transaction;
      }
    }
    //check quyền
    var arr_role = await this.$CoreService.checkPermission(this.$constants.KEY_MENU.LIST_SALE_PURCHASE);
    if (this.mode == 'edit') {
      if (arr_role.indexOf(this.$constants.ROLE.EDIT) < 0) {
        this.$router.push({ path: this.$constants.URL_ERR.FOBIDDEN });
      }
    } else {
      if (arr_role.indexOf(this.$constants.ROLE.ADD) < 0) {
        this.$router.push({ path: this.$constants.URL_ERR.FOBIDDEN });
      }
    }
    this.componentKey = (new Date()).getTime();
    console.log("this.componentKeythis.componentKey:", this.componentKey)
  },
  methods: {
    backToList() {
      this.$router.push({ path: '/admin/list-rental_order_sell' });
    },
    UpdateActive(key) {
      // console.log("key",key)
      var uid = this.$route.params.id;
      this.$commonFuction.is_loading(true);
      if (key == 'lock') {
        this.active_check = false
      } else {
        this.active_check = true
      }

      let variables = {
        'data_update': {
          'active': this.active_check
        },
        'where_key': {
          'id': { '_eq': this.$route.params.id }
        }
      };
      var that = this;
      this.$apollo.mutate({
        mutation: DataServices.updateData('users'),
        variables: variables
      }).then(async (res) => {
        console.log('Success', res);
        if (key == 'lock') {
          var query_t = `mutation {
            delete_jwt_token(where: { uid: {_eq: "${uid}"}}) {
              returning {
                id
              }
            }
          }`
          await that.$apollo.mutate({
            mutation: gql(query_t),
          })
        }
        that.$toast.add({ severity: 'success', summary: 'Success', detail: 'Save data successfully', life: 3000 })
      })
      this.$commonFuction.is_loading(false);
      // console.log("this.$route.params.id",this.$route.params.id)
    },
    tringToSlug(str) {
      return str
        .toLowerCase() 
        .trim() 
        .replace(/[\s\W-]+/g, '-')
        .replace(/^-+|-+$/g, '');
    },
    async saveData(params) {
      let objects1 = {};
      if (params?.rental_order?.booking_status == 'Request' || params?.rental_order?.booking_status === 1) {
        objects1.status = 'REQUEST_SELL';
      } else if (params?.rental_order?.booking_status == 'Reject' || params?.rental_order?.booking_status === 2) {
        objects1.status = 'REJECT_SELL';
      }else if (params?.rental_order?.booking_status == 'Complete' || params?.rental_order?.booking_status === 3) {
        objects1.status = 'COMPLETE_SELL';
      }else if (params?.rental_order?.booking_status == 'Approve' || params?.rental_order?.booking_status === 4) {
        objects1.status = 'APPROVE_SELL';
      } else if (params?.rental_order?.booking_status == 'Cancel' || params?.rental_order?.booking_status === 5) {
        objects1.status = 'CANCEL_SELL';
      } 
   
      let objects = {
        sell_showroom_id: params.sell_showroom_id ?? '',
        sell_drop_off_date: params.sell_drop_off_date ?? null,
        sell_plate_number: params.sell_plate_number ?? '',
        sell_rego_validation: params.sell_rego_validation ?? null,
        price: params.price ?? 0,
        odometer: params.odometer ?? null,
       
        fullname: params.fullname ?? '',
        phone: params.phone ?? '',
        email: params.email ?? '',
      };
      console.log(objects);
      
      var list_file = params?.list_file ?? [];
      var list_id_file_delete = params?.list_id_file_delete ?? [];
      this.triggerSave = false;
      console.log('objects',objects);
      if (this.mode === 'add') {console.log('params',params);}
      else if (this.mode === 'edit') {
        
        objects.created_at = moment.tz(new Date(), this.time_zone_local);
        objects.created_by = this.$store.getters.user;
        try {
            let rentalOrderSell;
              rentalOrderSell = await this.$apollo.mutate({
              mutation: DataServices.updateData('rental_order_sell'),
              variables: {
                'data_update': objects,
                'where_key': {
                  'id': { '_eq': params.id }
                }
              }
            });
          let returningRentalOrderSell = rentalOrderSell.data[Object.keys(rentalOrderSell.data)].returning[0];
          let resCar = await this.$apollo.mutate({
            mutation: DataServices.updateData('rental_order'),
            variables: {
              'data_update': {
                is_edit_admin: true,
                booking_status: objects1?.status ?? null,
                note : params?.rental_order?.note ?? '',
               
                updated_at: moment.tz(new Date(), this.time_zone_local),
                updated_by: this.$store.getters.user,
              },
              'where_key': {
                'id': { '_eq': returningRentalOrderSell.rental_order_id }
              }
            }
          });
          let returningCar = resCar.data[Object.keys(resCar.data)].returning[0];
          console.log('params.list_id_file_delete',params.list_id_file_delete);
          if (list_id_file_delete.length > 0){
              await this.$CoreService.deleteDataImageMulti(this.$constants.TYPE_IMAGE.CAR_SELL_REQUEST, list_id_file_delete)
          }
          if (list_file.length > 0) {
            const resImage = await this.$CoreService.uploadImages(this.$constants.FOLDER_S3.CAR_SELL_REQUEST, list_file);
            if (resImage && resImage.length > 0) {
              for (let i = 0; i < resImage.length; i++) {
                var objectImage = resImage[i];
                var objectImage_car_order = resImage[0];
                // lấy hình ảnh đầu tiên làm hình đại diện thêm vào CAR_ORDER
                if (i == 0) {
                  await this.$CoreService.updateDataImage(this.$constants.TYPE_IMAGE.CAR_ORDER, returningCar.id, objectImage_car_order);
                }
                await this.$CoreService.updateDataImage(this.$constants.TYPE_IMAGE.CAR_SELL_REQUEST, returningCar.id, objectImage).catch(async error => {
                  console.log('error', error);
                  this.$toast.add({
                    severity: 'error',
                    summary: this.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                    detail: this.$constants.MSG_TEXT.ERR_PLEASE_TRY_AGAIN,
                    life: 3000
                  });
                });
              }
            }
          }

           var list_user = [params?.rental_order?.uid];
           var params_noti =null;
           if(objects1.status == 'COMPLETE_SELL' && objects1.status != params.booking_status_root){

          var BUY_A_CAR_CUMULATIVE_SPENDING = await this.$CoreService.getSetting( "SELL_A_CAR_CUMULATIVE_SPENDING" ); 
          var BUY_A_CAR_CUMULATIVE_SPENDING_VALUE =!this.$commonFuction.isEmpty(BUY_A_CAR_CUMULATIVE_SPENDING.value) ? parseFloat(BUY_A_CAR_CUMULATIVE_SPENDING.value):0;
           
          

          var proportion_reward = parseInt( parseFloat(params.price_sale) / parseFloat(BUY_A_CAR_CUMULATIVE_SPENDING_VALUE) ); 
          console.log('proportion_rewardproportion_rewardproportion_reward',proportion_reward);
          
          var POINTS_REWARD_BUY = await this.$CoreService.getSetting( "POINTS_REWARD_SELL" ); 
          var POINTS_REWARD_BUY_VALUE =!this.$commonFuction.isEmpty(POINTS_REWARD_BUY.value) ? parseFloat(POINTS_REWARD_BUY.value):0;
           var point_value = proportion_reward*POINTS_REWARD_BUY_VALUE;
           if(point_value > 0){
        var params_change_point = {
            uid:params?.rental_order?.uid,
            description: `Reward - Completed sale a car #${params?.rental_order?.code} `,
            amount:parseFloat(point_value),
            updated_by:params?.rental_order?.uid,
            created_by:params?.rental_order?.uid,
            type: '4',
            object_id: returningRentalOrderSell.rental_order_id,
            status: 'ST002'
        }
        await this.$CoreService.changePoint(params_change_point);

 var params_noti_point ={
                title:"",
                content:"",
                short_content:`Thank you for selling your car with us! You've earned ${parseFloat(point_value)} points.`,
                short_content_noti:`Thank you for selling your car with us! You've earned ${parseFloat(point_value)} points.`,
                type:null,
                action_key:this.$constants.ACTION_KEY_NOTI.POINT_HISTORY,
                uid:null,
                multi_uid:list_user,
                //object_id:params.rental_order_id,
                is_admin:false,
                key_noti:1,//
              }
               await this.$CoreService.sendNoti(params_noti_point);
           }

            params_noti ={
                title:"",
                content:"",
                short_content:`[#${params?.rental_order?.code}] Your request to sell your car has been completed. `,
                short_content_noti:`[#${params?.rental_order?.code}] Your request to sell your car has been completed. `,
                type:null,
                action_key:this.$constants.ACTION_KEY_NOTI.DETAIL_ORDER,
                uid:null,
                multi_uid:list_user,
                object_id:returningRentalOrderSell.rental_order_id,
                is_admin:false,
                key_noti:3,//
              }
               await this.$CoreService.sendNoti(params_noti);
           }

           if(objects1.status == 'APPROVE_SELL' && objects1.status != params.booking_status_root){
            params_noti ={
                title:"",
                content:"",
                short_content:`[#${params?.rental_order?.code}] Congrats! Your request to sell your car has been approved. Please remember to arrive on time and bring your registration papers and driver's license to verify ownership at the drop-off showroom. `,
                short_content_noti:`[#${params?.rental_order?.code}] Congrats! Your request to sell your car has been approved. Please remember to arrive on time and bring your registration papers and driver's license to verify ownership at the drop-off showroom. `,
                type:null,
                action_key:this.$constants.ACTION_KEY_NOTI.DETAIL_ORDER,
                uid:null,
                multi_uid:list_user,
                object_id:returningRentalOrderSell.rental_order_id,
                is_admin:false,
                key_noti:3,//
              }
               await this.$CoreService.sendNoti(params_noti);
           }

           if(objects1.status == 'CANCEL_SELL' && objects1.status != params.booking_status_root){
            params_noti ={
                title:"",
                content:"",
                short_content:`[#${params?.rental_order?.code}] Your request to sell your car has been cancelled.  `,
                short_content_noti:`[#${params?.rental_order?.code}] Your request to sell your car has been cancelled.  `,
                type:null,
                action_key:this.$constants.ACTION_KEY_NOTI.DETAIL_ORDER,
                uid:null,
                multi_uid:list_user,
                object_id:returningRentalOrderSell.rental_order_id,
                is_admin:false,
                key_noti:3,//
              }
               await this.$CoreService.sendNoti(params_noti);
           }
         this.redirectEdit();
        } catch (error) {
          console.log('error', error);
          this.$toast.add({
            severity: 'error',
            summary: this.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
            detail: this.$constants.MSG_TEXT.ERR_PLEASE_TRY_AGAIN,
            life: 3000
          });
        }
      }

      this.$commonFuction.is_loading(false);


      this.$commonFuction.is_loading(false);
    },
    async redirectEdit() {
      var that = this;
      var router_back = { path: '/admin/list-rental_order_sell' };
      that.$toast.add({ severity: 'success', summary: 'Success', detail: 'Save data successfully', life: 3000 })
      //reload lại trang để update số bagde
      window.location.href = router_back.path;
      // that.$commonFuction.is_loading(false);
      // if (that.mode == 'add') {
      //   that.$router.push(router_back);
      // } else {
      //   if (!that.$commonFuction.isEmpty(router_back)) {
      //     // that.page_transaction = ""+that.page_transaction
      //     router_back.query = { page_transaction: that.page_transaction.toString() };
      //   }
      //   that.$router.push(router_back);
      // }
      // that.$toast.add({ severity: 'success', summary: 'Success', detail: 'Save data successfully', life: 3000 })
    },
    async getData(id) {
      var { data } = await this.$apollo.query({
        query: DataServices.getList('rental_order_sell'),
        variables: {
          where_key: {
            id: { '_eq': id }
          }
        },
        fetchPolicy: "network-only"
      })
      console.log("datadata:", data);
      var model = data[Object.keys(data)];
      if (model.length > 0) {
        this.models = model[0];
        var dataImageList = await this.$CoreService.getFileMapFile([this.$constants.TYPE_IMAGE.CAR_SELL_REQUEST], [this.models.rental_order.id]);

        this.models["list_file_edit"] = dataImageList.listData;
        console.log("this.models", this.models);
        
      }
      this.componentKey++;
    },
    async getDataColor(name) {
      try {
        const { data } = await this.$apollo.query({
          query: DataServices.getList('color'),
          variables: {
            where_key: {
              name: { _eq: name }
            }
          },
          fetchPolicy: "network-only"
        });
        if (data && data.color && data.color.length > 0) {
          this.modelsColor = data.color[0];
        }
        return this.modelsColor;
      } catch (error) {
        return null;
      }
    },
    async getNumberAuto() {
      try {
        const { data } = await this.$apollo.query({
          query: DataServices.getList('rental_order_sell'),
          variables: {
            where_key: {deleted : { _eq : false }},
            orderBy: { auto_in_number: 'desc' },
            limit: 1 
          },
          fetchPolicy: "network-only"
        });
        return data;
      } catch (error) {
        console.error('Error fetching the largest auto_in_number:', error);
        return null;
      }
    }


  },
  apollo: {

  }
}
</script>

<style lang="scss">
.manager-title-custom {
  color: #1D3118;
  font-size: 24px !important;
  /* margin-bottom: 16px; */
  padding-bottom: 20px;
  /* border-bottom: 1px solid #EEEEEE; */
  font-weight: 700;
  margin-left: 20px;
}

.p-inputnumber-buttons-stacked {
  .p-inputnumber-button-group {
    .p-button.p-button-icon-only {
      padding: 0 !important;
    }
  }
}

.note {
  letter-spacing: 0px;
  color: #707070;
  margin-bottom: 24px;
  padding-top: 10px;
}

.p-formgrid {
  margin: 0;

  .p-panel-header {
    color: #000000;
    font-size: 18px;
    font-weight: bold;
    background: #EEEEEE;
  }

  .p-card-field {
    padding: 24px;

    .p-field {
      .p-col-fixed {
        width: 300px;
        display: inline-block !important;
        margin: 0;
      }

      .p-col-width {
        width: 500px !important;
        border-radius: 5px;

        &.disabled {
          background: #EEEEEE;
          border: 0 none;
          padding: 8px 10px;
        }

        .file-select {
          margin: 0;

          input[type="file"] {
            display: none;
          }

          .select-button {
            display: inline-block;
            cursor: pointer;
            background: transparent;
            border-radius: 5px;
            color: #000000;
            font-size: 13px;
            padding: 3px 16px;
            border: 1px solid #B4B4B4;
          }
        }

        &.pac-target-input {
          height: 80px;
          word-break: break-all;
          overflow-wrap: break-word;
          resize: none;
        }
      }

      .box-images {
        margin: 0;
        margin-top: 10px;
        position: relative;

        .item-img {
          width: 150px;
          height: 150px;
          margin-right: 8px;
          margin-bottom: 8px;
          display: inline-flex;
          position: relative;

          img {
            max-width: 100%;
            height: auto;
            margin: 0 auto;
            object-fit: contain;
            padding: 5px;
          }

          .button-clear {
            border-radius: 10px;
            width: 24px;
            height: 24px;
            background: #F5564E;
            float: right;
            cursor: pointer;
            position: absolute;
            right: 0px;

            img {
              vertical-align: top;
            }
          }
        }
      }

      .p-invalid {
        display: block;
      }
    }
  }

  .fixed-bottom-toolbar {
    background: transparent;
    border: 0 none;
    margin-top: 22px;
    border-top: 1px solid #B4B4B4;
    padding: 0;
    padding-top: 30px;

    .p-button {
      width: auto;
      margin-right: 8px;

      &:last-child {
        margin-right: 0;
      }
    }
  }
}

.manager-title-row {
  border-bottom: 1px solid #EEEEEE;
}

.p-toolbar-group-right {
  flex-basis: 30%;
}

.p-button-warning.p-button {
  margin: 0 10px;
}
</style>
